/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Feature,
  FeatureOverview,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List the current user's features grouped by how they are enabled
 */
export const listFeatures = (

 signal?: AbortSignal
) => {


      return axiosClient<FeatureOverview>(
      {url: `/features`, method: 'GET', signal
    },
      );
    }




export const getListFeaturesQueryKey = () => {
    return [
    'features'
    ] as const;
    }


export const getListFeaturesQueryOptions = <TData = Awaited<ReturnType<typeof listFeatures>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFeatures>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListFeaturesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFeatures>>> = ({ signal }) => listFeatures(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFeatures>>, TError, TData>
}

export type ListFeaturesQueryResult = NonNullable<Awaited<ReturnType<typeof listFeatures>>>
export type ListFeaturesQueryError = ErrorType<void>


/**
 * @summary List the current user's features grouped by how they are enabled
 */

export function useListFeatures<TData = Awaited<ReturnType<typeof listFeatures>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFeatures>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListFeaturesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Toggle a feature on or off for the current user
 */
export const toggleFeature = (
    name: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      name = toValue(name);

      return axiosClient<Feature>(
      {url: `/features/${name}/toggle`, method: 'PATCH', signal
    },
      );
    }




export const getToggleFeatureMutationKey = () => ['toggleFeature'] as const;

export const getToggleFeatureMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleFeature>>, TError,ToggleFeatureMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof toggleFeature>>, TError,ToggleFeatureMutationVariables, TContext> => {

const mutationKey = getToggleFeatureMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleFeature>>, ToggleFeatureMutationVariables> = (props) => {
          const {name} = props ?? {};

          return  toggleFeature(name,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ToggleFeatureMutationResult = NonNullable<Awaited<ReturnType<typeof toggleFeature>>>

    export type ToggleFeatureMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type ToggleFeatureMutationVariables = {name: string}

    /**
 * @summary Toggle a feature on or off for the current user
 */
export const useToggleFeature = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleFeature>>, TError,ToggleFeatureMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof toggleFeature>>,
        TError,
        ToggleFeatureMutationVariables,
        TContext
      > => {
      return useMutation(getToggleFeatureMutationOptions(options), queryClient);
    }
